import LightboxLink from './LightboxLink';
import MainNav from './MainNav';
import MobileNav from './MobileNav';
import PageLoader from './PageLoader';
import Pages from './Pages';
import ParallaxElements from './ParallaxElements';
import TeamGriffinAdmin from './TeamGriffinAdmin';
//import ShoeBox from './ShoeBox';
import Subnavs from './Subnavs';
import Stats from './Stats';
import VideoList from "./VideoList";
import EasterEggs from "./EasterEggs";
import Newsletter from "./Newsletter";
import ImageUploader from "./ImageUploader";
import SideBar from "./SideBar";

const App = {

    started: false,

    init() {
        // Browser sniffing for URL for iNoBounce
        window.iOS =  window.App.isIOS();
        iNoBounce.disable();

        // Check URL to see if we need to show the mobile nav open or not
        window.App.checkURL();

        $(window).on('scroll', () => window.App.animateSection());
        $(window).trigger('scroll'); // initiate fading in .animate-in-section sections

        // Embed Grunticon SVG icons
        grunticon.embedIcons(grunticon.getIcons(grunticon.getCSS(grunticon.href)));

        // Initialize all the JS classes
        window.LightboxLink = new LightboxLink();
        window.MainNav = new MainNav();
        window.Subnavs = new Subnavs();
        window.MobileNav = new MobileNav();
        window.Pages = new Pages();
        window.PageLoader = new PageLoader();
        window.ImageUploader = new ImageUploader();
        window.SideBar = new SideBar();
        TeamGriffinAdmin.init();
    },


    /**
     * Determine if we are using an iPad of iPhone device
     * - this is required for the iNoBounce scrolling library
     * @returns {boolean}
     */
    isIOS() {
        var ua = navigator.userAgent;
        return (/iPhone/i.test(ua) || /iPod/i.test(ua) || /iPad/i.test(ua));
    },


    /**
     * Check initial website loading's url to determine
     * what to show/hide on page load
     */
    checkURL() {
        let data = window.App.getURL();
        // if we are on the homepage (url = '/'), show the nav only and hide the menu toggle
        if (data.count === 0) {
            $('.main-nav, .mobile-nav').addClass('open');
            $(".menu-toggle").hide();
            window.App.bounceScroll('enable');
        }
        // If we are on a landing page and the viewport is mobile,
        // show mobile nav
        else if (data.count === 1) {
            if ($(window).width() < 768) {
                $('.mobile-nav').addClass('open');
                $(".menu-toggle").hide();
            } else {
                $('.menu-toggle').show();
            }
            if (data.url[1] === 'eventsbyblake'){
                if ($(window).width() < 768) {
                    $('.mobile-nav').removeClass('open');
                    $(".menu-toggle").show();
                } else {
                    $('.menu-toggle').show();
                }
            }
            window.App.bounceScroll('enable');
        }
        // CLose the main and mobile nav if we are on a secondary/tertiary page
        else {
            $('.mobile-nav, .main-nav').removeClass('open');
            $(".menu-toggle").show();
             window.App.bounceScroll('disable');
        }
    },


    /**
     * Get the URL and its segments
     * @returns {{url: Array, count: number}}
     */
    getURL() {
        let url = window.location.pathname.split('/');
        let count = 0;
        // Check to see if we have more than 1 url segment
        url.forEach((item) => {
            (item.length > 0) ? count++ : null;
        });
        return  { url: url, count: count };
    },

    /**
     * Animate in animated sections when they are in view
     */
    animateSection() {
        let $window = $(window);
        let $animation_elements = $(".animate-in-section, .animate-in-section-clean");
        var window_height = $window.height();
        var window_top_position = $window.scrollTop();
        var window_bottom_position = (window_top_position + window_height);

        $.each($animation_elements, function() {
            var $element = $(this);
            var element_height = $element.outerHeight();
            var element_top_position = $element.offset().top + (window_height * 0.5);
            var element_bottom_position = (element_top_position + element_height);

            //check to see if this current container is within viewport
            if ((element_bottom_position >= window_top_position) &&
                (element_top_position <= window_bottom_position)) {
                $element.addClass('active');
            }
        });
    },

    /**
     * Re-initialize the needed classes
     */
    reInitialize() {
        window.ParallaxElements = new ParallaxElements();
        //window.ShoeBox = new ShoeBox();
        window.Stats = new Stats();
        window.VideoList = new VideoList();
        window.EasterEggs = new EasterEggs();
        window.ParallaxElements = new ParallaxElements();
        window.Stats = new Stats();
        window.VideoList = new VideoList();
        window.Newsletter = new Newsletter();
        window.Subnavs = new Subnavs();
        // Embed Grunticon SVG icons
        grunticon.embedIcons(grunticon.getIcons(grunticon.getCSS(grunticon.href)));
    },

    /**
     * Use the iNoBounce js library to fix the
     * ios rubber band effect when scrolling
     */
    bounceScroll(type) {
        if (window.iOS === true && $(window).width() <= 768) {
            (type === 'disable') ? iNoBounce.disable() : iNoBounce.enable();
        }
    }
};

$(window).on('load', () => { window.App = App; window.App.init(); });
// Force page to show after 4 seconds, after the DOM is ready
$(document).on('ready', () => {
    setTimeout(function () {
        if (typeof window.App === 'undefined') {
            window.App = App;
            window.App.init();
        }
    }, 4000);
});


// WEBPACK FOOTER //
// ./public/js/App.js